

















































import Vue from 'vue';

export default Vue.extend({
  name: 'SimpleModal',
  props: {
    show: { type: Boolean, default: false, },
    title: { type: String, default: '', },
    modalId: { type: String, default: 'simple-modal', },
    centered: { type: Boolean, default: true, },
    hideFooter: { type: Boolean, default: false, },
    staticModal: { type: Boolean, default: true, },
    noCloseOnBackdrop: { type: Boolean, default: false, },
    noCloseOnEsc: { type: Boolean, default: false, },
    showCancelButton: { type: Boolean, default: true, },
    showOkButton: { type: Boolean, default: true, },
    cancelText: { type: String, default: 'Cancelar', },
    okText: { type: String, default: 'Aceptar', },
    loading: { type: Boolean, default: false, },
    disabled: { type: Boolean, default: false, },
    size: { type: String, default: 'lg', }, // 'sm', 'md', 'lg', 'xl'
    dialogClass: { type: [String, Array, Object], default: null, },
  },
  computed: {
    syncedShow: {
      get(): boolean {
        return this.show;
      },
      set(value: boolean): void {
        this.$emit('update:show', value);
      },
    },
  },
  methods: {
    handleOk(): void {
      this.$emit('confirm');
    },
    handleCancel(): void {
      this.$emit('cancel');
      this.syncedShow = false;
    },
    onHidden(): void {
      this.$emit('hidden');
    },
    onShown(): void {
      this.$emit('shown');
    },
  },
});
